import { useDiffitUserContext } from '../contexts/DiffitUserContext';
import { currentProjectQuota } from '../utils/isProjectQuotaExceeded';

/** The signed-in user's weekly project quota as of this render, or null when it doesn't apply. */
export const useProjectQuota = () => {
  const { diffitUser } = useDiffitUserContext();
  return currentProjectQuota(diffitUser?.weekly_project_quota);
};
